const NOTIFICATION_ELE_TAG = 'descope-notification';

export { NOTIFICATION_ELE_TAG };
//# sourceMappingURL=constants.js.map
